import { createAsyncThunk } from '@reduxjs/toolkit'
import { decryptData } from 'utils/common-services/decrypt.service'
import { getAllCurrencyService, getGameSettingService, verifyRoundHashService } from 'network/services/gameSettings.service'
import { setAllCurrency } from 'redux-store/redux/slices/gameSettings.slice'
import { DEFAULT_GAME_ID } from 'utils/constants/index'

export const getAllCurrency = createAsyncThunk('user/getAllCurrency', async (data, thunkApi) => {
  try {
    // const res = await getAllCurrencyService()
    // thunkApi.dispatch(setAllCurrency(res))
    // if (res && res.length > 0) {
    return thunkApi.dispatch(getGameSetting(data))
    // }
    // return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getGameSetting = createAsyncThunk('system/get-game-settings', async (data, thunkApi) => {
  try {
    if (data?.demoMode) {
      // Fun mode has no settings API — Pingoo/Hubert default to 1% house edge (99% RTP) and 100x max odds;
      // Wire stays at 5% (95% RTP) and 5000x. Game Limits max win is maxBet * maxOdds (100 * 100 = FUN 10,000).
      const crashDemoGameIds = [DEFAULT_GAME_ID.PINGOO_GAME, DEFAULT_GAME_ID.MULTI_CRASH]
      const isCrashDemo = crashDemoGameIds.includes(Number(data?.gameId))
      const houseEdge = isCrashDemo ? 1 : 5
      const maxOdds = isCrashDemo ? 100 : 5000

      return [{
        gameId: data?.gameId,
        minBet: 0.1,
        maxBet: 100,
        maxProfit: 500000,
        houseEdge,
        minOdds: 1.04,
        maxOdds,
        minAutoRate: 1.1
      }]
    }

    let res = await getGameSettingService(data)
    res = await decryptData(res?.encryptedData, res?.iv)

    const currency = data?.currencyCode
    for (const [key, value] of Object.entries(res)) {
      if (typeof value !== 'object' && ['minBet', 'maxBet', 'maxProfit'].includes(key)) {
        res[key] = { [currency]: res[key] }
      }
    }
    return [{ ...res, gameId: data?.gameId }]
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const roundVerifyHash = createAsyncThunk(
  'verify/game-hash',
  async (data, thunkApi) => {
    try {
      const res = await verifyRoundHashService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
